export default "__VITE_ASSET__Cs08t0fi__"